// Resources
import { IStyles } from '../../../resource';

// Define styles
const styles: IStyles = {
  container: (theme) => ({
    minHeight: 300,
    alignItems: 'center',
    justifyContent: 'center',
    height: 'calc(100vh - 72px)',
    px: { xs: theme.spacing(20), sm: theme.spacing(80), md: theme.spacing(140) },
    backgroundImage: 'url(/images/login-bg.png)',
    backgroundPosition: theme.spacing(-320, -841),
    backgroundColor: theme.palette.gray.light,
    backgroundBlendMode: 'overlay',
  }),
  form: (theme) => ({
    mb: theme.spacing(16),
    width: '100%',
    maxWidth: 420,
  }),
};

// Export styles
export default styles;
